<template>
  <div class="content">
    <div class="cardContent">
      <div class="kxq">
        <div class="rowClass">
          <p>
            <span class="span-l">昵称:</span><span class="span-r">{{cardData.nickname}}</span>
          </p>
          <p>
            <span class="span-l">用户UserID:</span><span class="span-r">{{cardData.userId}}</span>
          </p>
          <p>
            <span class="span-l">手机号:</span><span class="span-r">{{cardData.phone}}</span>
          </p>
          <p>
            <span class="span-l">场景:</span><span class="span-r">{{cardData.scene}}</span>
          </p>
          <p>
            <span class="span-l">总积分:</span><span class="span-r">{{cardData.totalIntegral}}</span>
          </p>
          <p>
            <span class="span-l">卡积分:</span><span class="span-r">{{cardData.cardIntegral}}</span>
          </p>
          <p>
            <span class="span-l">账户积分:</span><span class="span-r">{{cardData.userIntegral}}</span>
          </p>
          <p>
            <span class="span-l">卡数量:</span><span class="span-r">{{cardData.cardNumber}}</span>
          </p>
          <p>
            <span class="span-l">余额:</span><span class="span-r">{{cardData.amount}}</span>
          </p>
          <p>
            <span class="span-l">充值金额:</span><span class="span-r">{{cardData.monthSale}}</span>
          </p>
          <p>
            <span class="span-l">创建时间:</span><span class="span-r">{{cardData.createTime}}</span>
          </p>
        </div>
        <div class="aloneClass">
          <p>
            <span class="span-l">备注显示：</span>
            <span class="span-r">{{cardData.remark}}
              <span style="position: relative;top: -5px;cursor: pointer;" v-hasPermi="['user:wxBind:remark']">
                <i class="el-icon-edit bianji-class" @click="editRow()"></i>
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="cardContent marge-class">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户卡列表" name="third">
          <userCardList ref="userCardListRef" :userId="userId"></userCardList>
        </el-tab-pane>
        <el-tab-pane label="用户充值列表" name="second">
          <userCzlist ref="userCzlistRef" :userId="userId"></userCzlist>
        </el-tab-pane>
        <el-tab-pane label="积分列表" name="fourth">
          <userIntegralList ref="userIntegralListRef" :userId="userId"></userIntegralList>
        </el-tab-pane>
        <el-tab-pane label="余额明细列表" name="fifth">
          <userBalanceList ref="userBalanceListRef" :userId="userId"></userBalanceList>
        </el-tab-pane>
        <el-tab-pane label="解绑卡明细" name="sixth">
          <userUnbundlingCardList ref="userUnbundlingCardListRef" :userId="userId"></userUnbundlingCardList>
        </el-tab-pane>
        <!-- <el-tab-pane label="备注列表" name="seventh">
          <userRemarkList ref="userRemarkListRef" :userId="userId"></userRemarkList>
        </el-tab-pane> -->
      </el-tabs>
    </div>
    <commonDialog
      :visible.sync="dialogRemark"
      dialogTitle="用户备注"
      popupWidth="470px"
      @dialogClose="dialogClose"
      @cancel="cancel"
      @save="save"
    >
      <el-form :model="beizhu" ref="beizhu">
        <el-form-item label="备注内容:" prop="remark" label-width="100px">
          <el-input type="textarea" v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
        </el-form-item>
      </el-form>
    </commonDialog>
  </div>
</template>
<script>
import userCzlist from "@/components/userDetails/userCzlist.vue";
import userCardList from "@/components/userDetails/userCardList.vue";
import userIntegralList from "@/components/userDetails/userIntegralList.vue";
import userBalanceList from "@/components/userDetails/userBalanceList.vue";
import userUnbundlingCardList from "@/components/userDetails/userUnbundlingCardList.vue";
import userRemarkList from "@/components/userDetails/userRemarkList.vue";
import commonDialog from "@/components/dialogComponent/commonDialog.vue"; //弹窗

import { wxUserInfo } from "@/api/api.js"; //卡详情的初始化数据
import { addWxUserRemark } from "@/api/api.js"; //卡详情的初始化数据
export default {
  name:'userBindInfo',
  data() {
    return {
      userId:'',
      activeName: "third",
      cardData:{},
      dialogRemark:false,
      beizhu:{
        remark:"",
      }
    };
  },
  components: {
    userCzlist,
    userCardList,
    userIntegralList,
    userBalanceList,
    userUnbundlingCardList,
    // userRemarkList,
    commonDialog
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "second") {
        this.$refs.userCzlistRef.initData();
      }else if(tab.name == "third"){
        this.$refs.userCardListRef.initData();
      }else if(tab.name == "fourth"){
        this.$refs.userIntegralListRef.initData();
      }else if(tab.name == "fifth"){
        this.$refs.userBalanceListRef.initData();
      }else if(tab.name == "sixth"){
        this.$refs.userUnbundlingCardListRef.initData();
      }else if(tab.name == "seventh"){
        this.$refs.userRemarkListRef.initData();
      }
    },
    transferFlowRatio(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    Realnamestatus(status) {
      let obj = {
        0: "未实名 ",
        1: "实名中",
        2: "已实名",
        3: "未通过",
        4: "已注销",
      };
      return obj[status];
    },
    // 初始化数据
    initData() {
      let params ={
        userId:this.userId
      }
      wxUserInfo(params).then(res => {
        if(res.data.code == 200){
          this.cardData = res.data.data;
          if(this.cardData.scene == null){
            this.cardData.scene = "无"
          };
          this.cardData.remark = this.cardData.remark == null || this.cardData.remark == "" ? "无" : this.cardData.remark;
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 备注的弹窗
    editRow(){
      this.dialogRemark = true;
      this.beizhu ={};
      this.$set(this.beizhu,"remark",this.cardData.remark)
    },
    // 备注右上角x按钮
    dialogClose(){
      this.dialogRemark = false;
    },
    // 备注取消按钮
    cancel(){
      this.dialogRemark = false;
    },
    // 备注确认按钮
    save(){
      let params = {
        userId:this.userId,
        remark:this.beizhu.remark,
      };
      addWxUserRemark(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("备注成功");
          this.dialogRemark = false;
          this.beizhu = {};
          this.initData();
        }
      })
    }
  },
  created() {
    this.userId = this.$route.params && this.$route.params.userId;
    this.initData();
  },
  mounted() {
    
  },
};
</script>
<style scoped lang="less">
  .cardContent{
    padding: 0 20px;
  }
  .kxq{
    width: 100%;
    .rowClass{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      p{
        width: 33.3%;
        padding: 8px 0;
      }
    }
    .span-l{
      display: inline-block;
      width: 30%;
      text-align: left;
      font-size: 14px;
      color: #606266;
    }
    .span-r{
      display: inline-block;
      width: 70%;
      font-size: 14px;
      color: #1890ff;
    }
  }
  .aloneClass{
    p{
      padding: 8px 0;
    }
    .span-l{
      display: inline-block;
      width: 10%;
      text-align: left;
      font-size: 14px;
      color: #606266;
    }
    .span-r{
      display: inline-block;
      width: 90%;
      font-size: 14px;
      color: #1890ff;
    }
  }
  .marge-class{
    margin-top: 18px;
    padding-bottom:40px ;
  }
  .aloneClass{
    p{
      padding: 8px 0;
    }
    .span-l{
      display: inline-block;
      width: 10%;
      text-align: left;
      font-size: 14px;
      color: #606266;
    }
    .span-r{
      display: inline-block;
      width: 90%;
      font-size: 14px;
      color: #1890ff;
    }
  }
  @media screen and (max-width: 750px){
    .rowClass p{
      width: 100% !important;
    }
    .aloneClass p{
      .span-l{
        width: 30%;
      }
      .span-r{
        margin-left:10px
      }
    }
  }
  @media screen and (min-width: 750px) and (max-width: 1310px){
    .rowClass p{
      width: 50% !important;
    }
    .aloneClass p{
      .span-l{
        width: 15% !important;
      }
      .span-r{
        width:85% !important;
      }
    }
  }
</style>  